/**
 * Formats an RBAC / legacy role string into a human-facing label.
 * `lead_mentor` → `Lead Mentor`, `supervisor` → `Supervisor`, etc.
 *
 * Pass `{ supervisor: true }` to override and always return "Supervisor"
 * (used where supervisor capability needs to be surfaced regardless of the
 * user's primary role string).
 */
export function formatRoleLabel(
  role: string | null | undefined,
  options?: { supervisor?: boolean },
): string | null {
  if (options?.supervisor) return "Supervisor";
  if (!role) return null;

  return role
    .toLowerCase()
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
